import { render, staticRenderFns } from "./ReadonlyFormularioComponent.vue?vue&type=template&id=435b7638"
import script from "./ReadonlyFormularioComponent.vue?vue&type=script&lang=js"
export * from "./ReadonlyFormularioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports